module.exports = __webpack_public_path__ + "img/qr-png.cae1b6e0.svg";